import { Component, EventEmitter, Input, OnChanges, Output, SimpleChanges } from '@angular/core';
import { time } from 'console';
import { AutoCompleteCompleteEvent } from 'primeng/autocomplete';
import { DropdownChangeEvent } from 'primeng/dropdown';
import { Loja } from 'src/app/core/models/loja.model';
import { Produto } from 'src/app/core/models/produto.model';
import { WeblabService } from 'src/app/core/services/weblab.service';
import { ToastrService } from 'ngx-toastr';

@Component({
  selector: 'app-novo-pedido-olho',
  templateUrl: './novo-pedido-olho.component.html',
  styleUrls: ['./novo-pedido-olho.component.scss']
})
export class NovoPedidoOlhoComponent implements OnChanges{

  @Input() titulo: string;
  @Input() olho: NovoPedidoOlho;
  @Input() olhoSelecionadoAmbos: any;
  @Input() produtosLentes: Array<Produto>;
  @Input() laboratorioSelecionado: Loja | undefined;
  produtosLentesFiltrado: Array<Produto>;

  @Output() DNPLongeChange = new EventEmitter<boolean>();
  @Output() ProdutoChange = new EventEmitter<Produto>();
  maxlength: number = 5;

  private autocompleteHandler: any = null;
  private hchangeProdutoEmit: any = null;

  constructor(private service: WeblabService, private toastr: ToastrService) { }

  ngOnChanges(changes: SimpleChanges): void {
    //
  }
  primaBasesHorizontal: any[] = [
    {
      id: 1,
      nome: 'Nasal'
    },
    {
      id: 2,
      nome: 'Temporal'
    },
    // {
    //   id: 3,
    //   nome: 'Inferior'
    // },
    // {
    //   id: 4,
    //   nome: 'Superior'
    // },
    // {
    //   id: 5,
    //   nome: 'Nasal Inferior'
    // },
    // {
    //   id: 6,
    //   nome: 'Nasal Superior'
    // },
    // {
    //   id: 7,
    //   nome: 'Temporal Inferior'
    // },
    // {
    //   id: 8,
    //   nome: 'Temporal Superior'
    // }
  ]

  primaBasesVertical: any[] = [
    // {
    //   id: 1,
    //   nome: 'Nasal'
    // },
    // {
    //   id: 2,
    //   nome: 'Temporal'
    // },
    {
      id: 3,
      nome: 'Inferior'
    },
    {
      id: 4,
      nome: 'Superior'
    },
    // {
    //   id: 5,
    //   nome: 'Nasal Inferior'
    // },
    // {
    //   id: 6,
    //   nome: 'Nasal Superior'
    // },
    // {
    //   id: 7,
    //   nome: 'Temporal Inferior'
    // },
    // {
    //   id: 8,
    //   nome: 'Temporal Superior'
    // }
  ]
  changeDNPLonge(event: Event) {
    this.DNPLongeChange.emit(true);
  }

  // changeAdicao(event: number) {
  //   // let adicao = this.olho.olhoAdicao
  //   let adicao = event;

  //   if (adicao) {
  //     let olhoLongeEsferico = this.olho.olhoLongeEsferico ?? 0;
  //     let olhoLongeDNP = this.olho.olhoLongeDNP ?? 0;

  //     this.olho.olhoPertoEsferico = olhoLongeEsferico + adicao;
  //     this.olho.olhoPertoCilindrico = this.olho.olhoLongeCilindrico;
  //     this.olho.olhoPertoEixo = this.olho.olhoLongeEixo;
  //     this.olho.olhoPertoDNP = olhoLongeDNP - 2.5;
  //   } else {
  //     this.olho.olhoPertoEsferico = this.olho.olhoLongeEsferico;
  //     this.olho.olhoPertoCilindrico = this.olho.olhoLongeCilindrico;
  //     this.olho.olhoPertoEixo = this.olho.olhoLongeEixo;
  //     this.olho.olhoPertoDNP = this.olho.olhoLongeDNP;
  //   }
  // }

  // changeEixoLonge($event: any) {
  //   console.log('eixo longe', $event, this.olho.olhoLongeEixo);
  // }

  blurLonge() {
    
    let adicao = this.olho.olhoAdicao 
    
    if (adicao) {
      let olhoLongeEsferico = this.olho.olhoLongeEsferico ?? 0;
      let olhoLongeDNP = this.olho.olhoLongeDNP ?? 0;

      this.olho.olhoPertoEsferico = Number(olhoLongeEsferico.toString().replace(',', '.')) + Number(adicao.toString().replace(',', '.'));
      this.olho.olhoPertoEsferico = this.formatarInputBlur(this.olho.olhoPertoEsferico);

      let cilindrico = this.olho.olhoLongeCilindrico ?? '';
      this.olho.olhoPertoCilindrico = this.formatarInputBlur(cilindrico);

      this.olho.olhoPertoEixo = this.formatarInputBlur(this.olho.olhoLongeEixo);
      this.olho.olhoPertoDNP = Number(olhoLongeDNP.toString().replace('.', '').replace(',', '.')) - 2.5;
      this.olho.olhoPertoDNP = this.formatarInputBlur(this.olho.olhoPertoDNP);
    }
    
    
    // else {
    //   this.olho.olhoPertoEsferico = this.olho.olhoLongeEsferico;
    //   this.olho.olhoPertoCilindrico = this.olho.olhoLongeCilindrico;
    //   this.olho.olhoPertoEixo = this.olho.olhoLongeEixo;
    //   this.olho.olhoPertoDNP = this.olho.olhoLongeDNP;
    // }
  }

  // parseNumber(value: string | undefined) {
  //   if (!value) value = '0';

  //   return Number(value.replace('.', '').replace(',', '.'));
  // }

  changeProdutoEmit($event: any) {
    // const self = this;
    // clearTimeout(this.hchangeProdutoEmit);
    // this.hchangeProdutoEmit = setTimeout(() => {
    //   self.ProdutoChange.emit(self.olho.olhoLente);
    // }, 1000);
  }

  async filterAutoComplete(event: AutoCompleteCompleteEvent) {
    const self = this;
    if (!self.laboratorioSelecionado) {
      return;
    }

    let query = event.query;
    let especie = undefined;
    let tipoComercializacao = undefined;
    if (self.laboratorioSelecionado.ramo == 1) {
      especie = "L";
      tipoComercializacao = "Loj,Amb";
    }
    else if (self.laboratorioSelecionado.ramo == 2) {
      especie = "L";
      tipoComercializacao = "Fab,Amb";
    }

    this.service.produtos(query, this.laboratorioSelecionado?.id, especie, tipoComercializacao, 1, 20).subscribe({
      next(resp) {
        const produtos = (resp.dados || []).map((p) => {
          let vlr_venda_tratado = p.preco_venda;
          let perc_desconto = p.desc_acresc_porcentagem === null ? 0 : p.desc_acresc_porcentagem;

          return {
            ...p,
            desc_acresc_porcentagem: perc_desconto,
            vlr_venda_tratado: vlr_venda_tratado,
            vlr_liquido_produto: vlr_venda_tratado > 0 && perc_desconto > 0 ? vlr_venda_tratado - (vlr_venda_tratado * perc_desconto / 100) : vlr_venda_tratado

          }
        });
        
        self.produtosLentesFiltrado = produtos;
      },
      error(error) {
        self.produtosLentesFiltrado = [];
        const status = error.status;
        const message = error.error?.erro?.mensagem || error.message;
        if (status == 404) {
          //
        }
        else {
          self.toastr.error(message, 'Erro');
        }
      }
    });
  }

  isNegative(text: any) {
    text = (text || "").toString().replace(',', '.');
    let number = isNaN(text as any) ? 0 : parseFloat(text);
    return number < 0;
  }

  isOnlyNumbers(text: string): boolean {
    const regex = /^\d+$/;
    return regex.test(text);
  }

  eixoMinMax(el: any) {
    setTimeout(() => {
      if (el.value != '') {
        if (parseInt(el.target.value) < el.target.min) {
          el.target.value = el.target.min;
        }
        if (parseInt(el.target.value) > el.target.max) {     
          el.target.value = el.target.max;
        }
      }
      this.olho.olhoLongeEixo = el.target.value;
    }, 500);
  }  

  formatarInput(input: any, campo?: string, allowEmpty?: boolean): void {
    let inputNumericValue = input.value.replace(/[^\d.-]/g, '');

    if (campo === 'adicao') {
      inputNumericValue = inputNumericValue.replace(/-/g, '');
    }

    const isNegative = inputNumericValue.startsWith('-');
    const isPositive = !isNegative;
    const isEmpty = !!(inputNumericValue === '' || inputNumericValue === undefined || inputNumericValue === null);
    if (isEmpty && allowEmpty) {
      input.value = '';
      return;
    }

    if (isPositive || isNegative) {

      let number = parseFloat(inputNumericValue) / 100;
      if (number == 0 && allowEmpty) {
        return;
      }

      this.maxlength = isPositive ? 5 : 6;

      // Verificar o campo adição está com valor máximo permitido (somente valores positivos)
      let maxAllowed ;
      if (campo === 'adicao') {
        maxAllowed = 9.99;

        if (number > maxAllowed) {
          number = maxAllowed;
        } else if (number < 0) {
          number = 0;
        }

      }

      let formattedValue = number.toLocaleString('pt-BR', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
      if (formattedValue === 'NaN') {
          formattedValue = '-';
      }
      //
      input.value = formattedValue;

      this.receberValorConvertido(formattedValue, campo);

    } else {
        input.value = '';
    }
  }

  receberValorConvertido(valor: any, campos?: string) {
    switch (campos) {
      case 'esfericoLonge':
        this.olho.olhoLongeEsferico = valor
        break;
      case 'dnpLonge':
        this.olho.olhoLongeDNP = valor
        break;
      case 'cilindricoLonge':
        this.olho.olhoLongeCilindrico = valor;
        break;
      case 'esfericoPerto':
        this.olho.olhoPertoEsferico = valor
        break;
      case 'dnpPerto':
        this.olho.olhoPertoDNP = valor
        break;
      case 'cilindricoPerto':
        this.olho.olhoPertoCilindrico = valor;
      break;
      case 'adicao':
        this.olho.olhoAdicao = valor;
        break;        
      case 'altura_pupila':
        this.olho.olhoAlturaPupila = valor;
        break;        
        case 'prisma_hor_valor':
          this.olho.olhoPrismaHorizontalValor = valor;
          break; 
        case 'prisma_vert_valor':
          this.olho.olhoPrismaVerticalValor = valor;
          break;
      default:
        break;
    }
  }

  converterValor(decimalStr: string) {
    const inputNumericValue = decimalStr.replace(/[^\d.-]/g, '');
    const isNegative = inputNumericValue.startsWith('-');

    let number = parseFloat(inputNumericValue) / 100;

    let formattedValue = number.toLocaleString('pt-BR', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
    if (formattedValue === 'NaN') {
        formattedValue = '-';
    }
    let valorFormatado = formattedValue;
      
    return valorFormatado;
  }

  formatarInputBlur(input: any) {

    const formatoNovo = input.toLocaleString('pt-BR', {minimumFractionDigits: 2, maximumFractionDigits: 2});

    return formatoNovo

  }

}

export interface NovoPedidoOlho {
  olhoLongeEsferico?: number | undefined;
  olhoLongeCilindrico?: number | undefined;
  olhoLongeEixo?: number | undefined;
  olhoLongeDNP?: number | undefined;

  olhoAdicao?: number | undefined;

  olhoPertoEsferico?: number | undefined;
  olhoPertoCilindrico?: number | undefined;
  olhoPertoEixo?: number | undefined;
  olhoPertoDNP?: number | undefined;

  olhoAlturaPupila?: number | undefined;
  olhoPrismaHorizontalValor?: number | undefined;
  olhoPrismaVerticalValor?: number | undefined;
  olhoPrismaHorizontalBase?: any | undefined;
  olhoPrismaVerticalBase?: any | undefined;

}
